/* NOTE: BOOKING is not currently used, but we have decided to keep it
  in case we want to return to the original RoomTypeTile style. */

export enum RoomTypeComponentVariant {
  BOOKING = 'BOOKING',
  BOOKING_BED_BANKS = 'BOOKING_BED_BANKS',
  LANDING = 'LANDING'
}
